import React from 'react';
import { Box, CircularProgress, CircularProgressLabel, Flex, Text } from '@chakra-ui/react';
import { BiMale, BiFemale } from "react-icons/bi";

const AdminDashboardGenderReport = ({ genderReport }) => {
  const maleCount = genderReport?.male || 0;
  const femaleCount = genderReport?.female || 0;
  const malePercentage = genderReport?.malePercentage || 0;
  const femalePercentage = genderReport?.femalePercentage || 0;

  return (
    <Box py={"30px"} px={3} h={['100%','100%','300px']}  bgColor={"#FFFFFF"} borderRadius={"14px"} border={"1px solid #E3EBEE"}>
      <Text fontSize={'14px'} fontWeight={'500'} letterSpacing={'-0.154px'} color={'#D73439'}>
        Gender Report
      </Text>
      <Flex mt={5} gap={8} justifyContent={'center'} alignItems={'center'}>
        <Flex flexDirection={'column'} alignItems={'center'} gap={4}>
          <CircularProgress value={malePercentage} color='#812773' size='120px' capIsRound>
            <CircularProgressLabel>
              <Flex gap={1} justifyContent={'center'} alignItems={'center'}>
                <BiMale style={{ color: '#812773' }} />
                <Text color={'#000000'} fontSize={'16px'} fontWeight={'600'} fontFamily={'inter'}>
                  {malePercentage.toFixed(0)}%
                </Text>
              </Flex>
            </CircularProgressLabel>
          </CircularProgress>
          <Flex gap={2} alignItems={'center'}>
            <Box bg={"#812773"} h={2} w={2} borderRadius="50%" />
            <Text color={'#474747'} fontSize={'14px'} fontWeight={'600'} letterSpacing={'-0.154px'} fontFamily={'inter'}>
              {maleCount.toLocaleString()} <span style={{ fontWeight: "400" }}>(Males)</span>
            </Text>
          </Flex>
        </Flex>
        <Flex flexDirection={'column'} alignItems={'center'} gap={4}>
          <CircularProgress value={femalePercentage} color='#D11A2A' size='120px' capIsRound>
            <CircularProgressLabel>
              <Flex gap={1} justifyContent={'center'} alignItems={'center'}>
                <BiFemale style={{ color: '#D11A2A' }} />
                <Text color={'#000000'} fontSize={'16px'} fontWeight={'600'} fontFamily={'inter'}>
                  {femalePercentage.toFixed(0)}%
                </Text>
              </Flex>
            </CircularProgressLabel>
          </CircularProgress>
          <Flex gap={2} alignItems={'center'}>
            <Box bg={"#D11A2A"} h={2} w={2} borderRadius="50%" />
            <Text color={'#474747'} fontSize={'14px'} fontWeight={'600'} letterSpacing={'-0.154px'} fontFamily={'inter'}>
              {femaleCount.toLocaleString()} <span style={{ fontWeight: "400" }}>(Females)</span>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default AdminDashboardGenderReport;
